<template>
  <div
    class="p-5 border-4 border-solid border-light rounded-sm w-[46%] max-tablet:w-[75%] max-mobile:w-[100%] my-[2rem] [.webview_&]:mt-0"
  >
    <div class="flex gap-4 items-center">
      <DbcSvg name="dbc-icon-info" />
      <UtilityText class="m-0 [&>ul]:m-0 [&>ul]:mt-2" :text="message" />
    </div>
  </div>
</template>

<script setup lang="ts">
interface Props {
  severity: 'success' | 'warn' | 'info' | 'error'
  message: string
}

withDefaults(defineProps<Props>(), {
  severity: 'info',
})
</script>
